export default "/icons/google_play_icon.svg";